'use client';

import { type ReactNode, useEffect, useState } from 'react';
import { ListFilterItemDTO } from '@/features/filters/types/filters.dto';
import {
  filterBoxBase,
  filterBoxChecked,
  filterBoxUnchecked
} from '@/features/products/components/list/filters/filterBoxStyles';
import { FilterLabel } from '@/features/products/types/filterLabel';

const filterBoxFocusRing =
  'peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-(--mui-palette-primary-main)';

interface FilterCheckboxRowProps {
  filter: ListFilterItemDTO;
  checked: boolean;
  onToggle: (filterCode: string) => void;
  renderFilterLabel?: (filterLabel: FilterLabel) => ReactNode;
}

export const FilterCheckboxRow = ({
  filter,
  checked,
  onToggle,
  renderFilterLabel
}: FilterCheckboxRowProps) => {
  const [optimisticChecked, setOptimisticChecked] = useState(checked);

  useEffect(() => {
    setOptimisticChecked(checked);
  }, [checked]);

  const handleChange = () => {
    setOptimisticChecked((previous) => !previous);
    onToggle(filter.code);
  };

  return (
    <label className="relative flex cursor-pointer items-center gap-3 py-2 text-sm">
      <input
        type="checkbox"
        name={filter.name}
        checked={optimisticChecked}
        onChange={handleChange}
        className="peer sr-only"
      />
      <span
        aria-hidden="true"
        className={`${filterBoxBase} ${filterBoxFocusRing} ${optimisticChecked ? filterBoxChecked : filterBoxUnchecked}`}
      />
      {renderFilterLabel ? (
        renderFilterLabel({ filter })
      ) : (
        <>
          <span>
            {filter.name}{' '}
            {!!filter.count && (
              <span className="text-(--mui-palette-text-disabled)">({filter.count})</span>
            )}
          </span>
        </>
      )}
    </label>
  );
};
